import React, { Component, ReactDOM } from 'react'
import injectSheet from 'react-jss'
import Color from 'color'
import { Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
// import { flexUtils, palette } from '../../../Theme/Theme'
import * as Actions from '../../../Actions/Actions'
import _ from 'lodash'
import { palette } from '../../../Theme/Theme'
import ThumbNail from './thumbNail.jsx'
import { isMobile } from "react-device-detect";
import styled, { keyframes } from "styled-components";
// import ReactGA from 'react-ga'
// import Responsive from 'react-responsive'
// let ScrollAmount = 100

// const Desktop = props => <Responsive {...props} minWidth={736}/>
// const Mobile = props => <Responsive {...props} maxWidth={735}/>

const Container = styled.div`
    height: ${props => props.isMobile ? 'auto' : '13vw'};
    margin-left: ${props => props.isMobile ? '1vw' : '0' };
    min-width: 100vw;
    overflow-x: scroll;
    overflow-y: hidden;
    display: flex;
    flex-direction: row;
    justify-content: ${props => props.isMobile ? 'flex-start' : 'center'};
    flex-wrap: ${props => props.isMobile ? 'wrap' : 'nowrap'};
    align-items: center;
`

class Thumbnails extends Component {
  constructor (props) {
    super(props)
    this.chooseShow = this.chooseShow.bind(this)
    this.scroll = this.scroll.bind(this)
    this.hideArrow = this.hideArrow.bind(this)
    this.showArrow = this.showArrow.bind(this)
    this.state = {
      thumbNails: [],
      hasScrolled: false,
      ref: null,
      scrollAmount: 0,
      scrollConstant: 18.2,
      originalConstant: 18.2,
      Opacity: 1,
      width: 0
    }
  }

  render () {
    const { classes } = this.props
    const { Body } = classes
    let thumbNails
    let buttonClass
    // console.log(this.state.thumbNails)
    return (
      <React.Fragment>
        <Container isMobile={isMobile} id='row'>
          {parseFloat(this.state.scrollAmount) > -1 && parseFloat(this.state.scrollAmount) < 1 ? null : <div style={{opacity: this.state.Opacity}} onClick={() => { this.scroll('left') }} className={classes.scrollButtonLeft}><i className={`${classes.arrowLeft} fas fa-arrow-left`}></i></div>}
          <div className={`${classes.block}`} style={{margin: `${this.state.scrollAmount}vw`, width: '0px', height: '0px', backgroundColor: 'red'}}></div>
          {
            this.state.thumbNails.map((content, index) => {              
              if (isMobile) {
                content.index = index
              }
              return (                
                <ThumbNail rowNum={this.props.rowNum} isMobile={isMobile} key={index} index={index} mouseLeave={this.showArrow} hover={this.hideArrow} thumbnailImageUrl={content.thumbnailImageUrl} content={content}/>
              )
            })
          }
          { this.canScroll() ? <div style={{opacity: this.state.Opacity}} onClick={() => { this.scroll('right') }} className={classes.scrollButtonRight}><i className={`${classes.arrowRight} fas fa-arrow-right`}></i></div> : null}
        </Container>
      </React.Fragment>
    )
  }

  chooseShow (url, title) {
    this.props.dispatch(Actions.ChooseShow(url, title))
    this.props.history.push('/Home/Show')
  }

  showArrow () {
    this.setState({Opacity: 1})
  }

  hideArrow () {
    this.setState({Opacity: 0})
  }

  canScroll () {
    if (isMobile) return false

    if (this.props.thumbNails.length <= 5 || ((((this.props.thumbNails.length - 5) * 18.2) * -1) >= parseFloat(this.state.scrollAmount))) {
      return false
    }
    return true
  }

  scroll (direction) {
    let num = parseFloat(this.state.scrollAmount)
    let newConstant
    if (direction === 'right') {
      if (this.props.thumbNails.length > 10 && this.props.thumbNails.length % 5 !== 0) {
        let showsOffScreen = (((this.props.thumbNails.length * 18.2) - (-1 * parseFloat(this.state.scrollAmount))) / 18.2) - 5
        if (showsOffScreen < 5) {
          newConstant = (showsOffScreen * 18.2)
          this.setState({scrollAmount: (num - newConstant).toFixed(1)})
        } else {
          this.setState({scrollAmount: (num - this.state.scrollConstant).toFixed(1)})
        }
      } else {
        this.setState({scrollAmount: (num - this.state.scrollConstant).toFixed(1)})
      }
    } else {
      let showsToLeft = (this.state.scrollAmount * -1) / 18.2
      if (showsToLeft < 5) {
        newConstant = (showsToLeft * 18.2)
        this.setState({scrollAmount: (num + newConstant).toFixed(1)})
      } else {
        this.setState({scrollAmount: (num + this.state.scrollConstant).toFixed(1)})
      }
    }
  }

  componentDidMount () {
    let row = JSON.parse(JSON.stringify(this.props.thumbNails))
    row = row.map((o, index) => {
      o.index = index
      return o
    })
    // console.log(row)

    let padding = []    
    if (isMobile) {
      this.setState({thumbNails: row})
      return
    }

    if (row.length === 5) {
      this.setState({thumbNails: _.concat(padding, row)})
    }

    if (row.length < 5) {
      for (let i = 0; i < (5 - row.length); i++) {
        // if(row[0].type === 'playlist'){
        //   console.log('made it here')
        // }
        padding[i] = {thumbnailImageUrl: ''}
      }
      this.setState({thumbNails: _.concat(row, padding)})
    } else if (row.length > 5) {
      for (let i = 0; i < row.length - 5; i++) {
        padding[i] = {thumbnailImageUrl: ''}
      }
      this.setState({thumbNails: _.concat(padding, row)})
    }

    if (this.props.thumbNails.length > 5 & this.props.thumbNails.length < 10) {
      let constant = (this.props.thumbNails.length - 5) * 18.2
      this.setState({scrollConstant: constant, originalConstant: constant})
    } else if (this.props.thumbNails.length >= 10) {
      let constant = 5 * 18.2
      this.setState({scrollConstant: constant, originalConstant: constant})
    }
  }
}

const styles = {
  img: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  block: {
    transition: 'margin .4s',
    margin: '0',
    zIndex: '0'
  },
  Body: {
    height: '13vw',
    minWidth: '100vw',
    overflowX: 'scroll',
    overflowY: 'hidden',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  thumbnail: {
    transition: 'all .4s',
    transitionDelay: '300ms',
    transitionTimingFunction: 'cubic-bezier(.77,.06,.47,.83)',
    width: '18vw',
    minWidth: '18vw',
    boxShadow: `2px 2px 10px rgb(0,0,0)`,
    verticalAlign: 'bottom',
    marginRight: '.1vw',
    marginLeft: '.1vw',
    margin: '1vw',
    zIndex: '2',
    '&:hover': {
      cursor: 'pointer',
      zIndex: '2',
      transform: 'scale(1.2,1.2)',
      marginLeft: '2vw',
      marginRight: '2vw'
    }
  },
  scrollButtonRight: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '2rem',
    transition: 'all .4s',
    backgroundColor: Color(palette.white).alpha(0.4).toString(),
    color: Color(palette.black).alpha(1).darken(0.2).toString(),
    // borderRadius: '5px 0px 0px 5px', 195.359px
    width: '4.4vw',
    height: '10.175vw',
    right: '0',
    position: 'absolute',
    zIndex: '1',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: Color(palette.white).alpha(0.9).toString(),
      color: Color(palette.black).darken(0.7).alpha(1).toString()
    }
  },
  scrollButtonLeft: {
    extend: 'scrollButtonRight',
    // borderRadius: '0px 5px 5px 0px',
    left: '0'
  },
  arrowLeft: {
    paddingRight: '.5vw',
    zIndex: '2',
    fontSize: '2vw'
  },
  arrowRight: {
    paddingLeft: '.5vw',
    zIndex: '2',
    fontSize: '2vw'
  }
}

const mapStateToProps = state => {
  return {
    user: state.mainState.user,
    libraryState: state.mainState.libraryState,
    library: state.mainState.library,
    heroUrl: state.mainState.heroUrl
  }
}

export default withRouter(connect(mapStateToProps)(injectSheet(styles)(Thumbnails)))



// WEBPACK FOOTER //
// ./src/js/Components/Home/Shows/Thumbnails.jsx